import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FeedbackPointsModal } from 'src/app/api-providers/models/feedback.model';
import { FeedbackViewModel } from 'src/app/api-providers/view-models/feedback.view.model';

@Component({
  selector: 'app-top-feedback-users',
  templateUrl: './top-feedback-users.component.html',
  styleUrls: ['./top-feedback-users.component.scss']
})
export class TopFeedbackUsersComponent {
  feedbackUserPointsModel = new BehaviorSubject<FeedbackPointsModal>(new FeedbackPointsModal);
  pointsList = []
  constructor(private vm: FeedbackViewModel){
    this.vm.feedbackComponent = this
  }

  ngOnInit(): void {
    this.vm.subscribeToFeedbackUserPoints(this.feedbackUserPointsModel)
    this.vm.getTopFeedbackUser()
  }

  feedbacklistReceived(e){

    // function sortFn(a:any,b:any){
    //   if(a.sum > b.sum){
    //     return -1
    //   }
    //   else if(a.sum == b.sum){
    //     return 0
    //   }
    //   else if(a.sum < b.sum){
    //     return 1
    //   } else{
    //     return null
    //   }
    // }
    let sortVal = this.feedbackUserPointsModel.value.results.sort( (a,b) => {
      if(a.sum > b.sum){
        return -1
      }
      else if(a.sum == b.sum){
        return 0
      }
      else if(a.sum < b.sum){
        return 1
      } else{
        return null
      }
    } )
    this.pointsList = sortVal
  }

}
